import { render } from "./NotFoundPage.vue?vue&type=template&id=dff8eff4"
const script = {}
script.render = render

export default script